@if (screenInfo$ | async; as screen) {
<div class="bottom-small" [ngClass]="{ 
    'bottom-collapsed': workareaSize === 'small', 
    'bottom-m-xsmall': workareaSize === 'medium' && screen.size === 'XSmall', 
    'bottom-m-small': workareaSize === 'medium' && screen.size === 'Small',
    'bottom-m-medium': workareaSize === 'medium' && screen.size === 'Medium',
    'bottom-m-large': workareaSize === 'medium' && screen.size === 'Large',
    'bottom-m-xlarge': workareaSize === 'medium' && screen.size === 'XLarge',
    'bottom-l-xsmall': workareaSize === 'large' && screen.size === 'XSmall', 
    'bottom-l-small': workareaSize === 'large' && screen.size === 'Small',
    'bottom-l-medium': workareaSize === 'large' && screen.size === 'Medium',
    'bottom-l-large': workareaSize === 'large' && screen.size === 'Large',
    'bottom-l-xlarge': workareaSize === 'large' && screen.size === 'XLarge',
    'bottom-fullscreen': workareaSize === 'fullscreen'
    }">
    @for (system of [selectedsystem]; track trackBySerial($index, system)) {
      <sh-box id="work-area-box-1" background="surface" layout="vertical" elevation="none" style="height: 100%"
        [tabindex]="workareaSize === 'small' ? -1 : 0">
        <sh-box-section id="work-area-box-section-2" [system]="system" style="height: 100%; padding-top: 12px;">
          <!-- System Health Details -->
          @if (selectedWidget === 'instrument' && activeTab === 'Maintenance') {
            <div id="maintenance"
              style="height: 100%; width: 100%">
              <app-maintenance-details [tabs]="availableTabs"
              style="height: 100%; width: 100%"></app-maintenance-details>
            </div>
          }
          @if (selectedWidget === 'instrument' && activeTab === 'Autocheck') {
            <div id="autocheck"
              style="height: 100%; width: 100%">
              <app-autocheck-details [tabs]="availableTabs" style="height: 100%; width: 100%"></app-autocheck-details>
            </div>
          }
          @if (selectedWidget === 'instrument' && activeTab === 'Events') {
            <div id="events"
              style="height: 100%; width: 100%">
              <app-errors [tabs]="availableTabs" style="height: 100%; width: 100%"></app-errors>
            </div>
          }
          <!-- Service History Details -->
          @if (selectedWidget === 'service-history' && activeTab === 'Notifications') {
            <div id="notifications"
              style="height: 100%; width: 100%">
              <app-ms-notifications [tabs]="availableTabs" style="height: 100%; width: 100%"></app-ms-notifications>
            </div>
          }
          @if (selectedWidget === 'service-history' && activeTab === 'Spare Parts Used') {
            <div id="parts"
              style="height: 100%; width: 100%">
              <app-spare-parts [tabs]="availableTabs" style="height: 100%; width: 100%"></app-spare-parts>
            </div>
          }
          @if (selectedWidget === 'service-history' && activeTab === 'Activities') {
            <div id="visits"
              style="height: 100%; width: 100%">
              <app-activities [tabs]="availableTabs" style="height: 100%; width: 100%"></app-activities>
            </div>
          }
          @if (selectedWidget === 'service-history' && activeTab === 'Proactive Alarms') {
            <div id="alarms"
              style="height: 100%; width: 100%">
              <app-psm-details [tabs]="availableTabs" style="height: 100%; width: 100%"></app-psm-details>
            </div>
          }
          @if (selectedWidget === 'upcoming-services') {
            <app-upcoming-services-details style="height: 100%; width: 100%"></app-upcoming-services-details>
          }
          <!-- <div *ngIf="selectedWidget === 'upcoming-services' && activeTab === 'Outstanding PMS'" id="alarms"
          style="height: 100%; width: 100%">
          <app-upcoming-activity-details [tabs]="availableTabs" style="height: 100%; width: 100%"></app-upcoming-activity-details>
        </div> -->
        @if (selectedWidget === 'service-history' && activeTab === 'Escalations') {
          <div id="escalations"
            style="height: 100%; width: 100%">
            <app-escalations [tabs]="availableTabs" style="height: 100%; width: 100%"></app-escalations>
          </div>
        }
        <!-- <app-metrics-details *ngIf="selectedWidget === 'service-metrics'"></app-metrics-details> -->
        @if (selectedWidget === 'site') {
          <app-funcloc-details style="height: 100%; width: 100%"></app-funcloc-details>
        }
        <app-bookmark-menu style="height: 100%; width: 100%" [style.display]="selectedWidget === 'bookmark' ? 'block' : 'none'"></app-bookmark-menu>
        <!-- <app-upcoming-activity-details style="height: 100%; width: 100%" *ngIf="selectedWidget === 'upcoming-services'"></app-upcoming-activity-details> -->
      </sh-box-section>
    </sh-box>
  }
</div>
}